<template>
<div class="full" :class="{ focused: focused }">
  <div class="overlay-layer" v-if="show === 'mainscreen'">
    <ChatBoxTitle>
      <div slot="left">
        <!-- <img class="hide-desktop" src="../img/solid-heart-add.svg" @click="$emit('openMenu', true)" alt="Menu"> -->
        <!-- <img class="hide-desktop" src="../img/home.svg" style="cursor: pointer;" @click="() => { $router.push('/lab') }" alt="Home"> -->
        <img class="hide-desktop" src="../img/on-ui.svg" @click="$emit('switch', 'off')" alt="Home" title="Home">
        <img class="show-desktop" src="../img/qr.svg" style="cursor: pointer;" @click="() => { show = 'qrcode' }" alt="Qr Code">
      </div>
      <div slot="center" v-if="room">
        <span class="scroll-to-top title-link" @click="$refs['dialogue'].$emit('scroll-to-top')">{{ room.title.split('').slice(0, 20).join('') }}...</span>
        <!-- <a class="title-link" target="_blank" :href="`https://yoteachapp.com/room/${room._id}`" v-if="room && room.title">{{ room.title }}</a> -->
      </div>
      <div slot="right">
        <!-- <img src="../img/qr.svg" style="cursor: pointer;" @click="() => { show = 'qrcode' }" alt="Qr Code"> -->
        <img class="hide-desktop" :style="{ marginRight: '5px' }" src="../img/home.svg" @click="$emit('openMenu', true)" alt="Home" title="Home">
        <img src="../img/dot3.svg" @click="show = 'features'" alt="Menu" style="cursor: pointer;">
      </div>
    </ChatBoxTitle>

    <div class="chatty-conversation" v-if="room">
      <div class="dialogue-area">
        <Dialogue2 ref="dialogue" d-go-login="show = 'login'" @view-reply="onViewReply" @reply="onReply" :uploadProgress="uploadProgress" v-if="room" @room="(v) => { room = v }" :roomPW="roomPW" :isRoomAdminLoggedIn="isRoomAdminLoggedIn()" :room="room" :roomID="roomID" @remix="onRemix"></Dialogue2>
      </div>
      <div class="bottom-input-area">
        <div class="input-group" v-if="!isCurrentUserMuted()">
          <div class="reply-block reply-to" v-if="replyToID && currentReplyMsg">
            <div class="label">
              Replying to: {{ currentReplyMsg.senderName }}
              <br />
              <div v-if="currentReplyMsg.type === 'text'">
              Message:  {{ currentReplyMsg.text }}
              </div>
              <div v-if="currentReplyMsg.type === 'img'">
              </div>
              <img v-if="currentReplyMsg.imgURL" :src="currentReplyMsg.imgURL" class="img-preview" alt="">
              <b @click="replyToID = ''">Cancel</b>
            </div>
          </div>

          <TextInputer class="textarea ta" ref="textinput" @text="onTextInput" :focused="focused" @focus="focused = true" @blur="focused = false" />

          <img @click="$nextTick(() => { show = 'drawboard'; }); cleanBoard()" class="button icon" src="../img/pencil.svg" alt="">
          <input type="file" ref="filer" @change="onFileChange" v-show="false" accept="image/*" />
          <img @click="show = 'drawboard'; $refs['filer'].click()" class="button icon" src="../img/camera.svg" alt="">
          <img @click="show = 'myscript'; " class="button icon" src="../img/myscript-shorter.svg" alt="">
          <img v-show="isRoomAdminLoggedIn()" @click="onSendPoll" class="button icon" src="../img/poll.svg" alt="">

          <img v-show="!sending" @click="onSendText" @touchend="onSendText()" class="red-circle-icon" src="../img/plane-white.svg" alt="">
          <img v-show="sending" class="red-circle-icon" src="../img/clock.svg" alt="">

        </div>
        <div class="you-are-muted" v-if="isCurrentUserMuted()">
          You are muted. 🔇🤐
        </div>
      </div>
    </div>
  </div>

  <div class="overlay-layer" v-if="show === 'features'">
    <ChatBoxTitle>
      <div slot="left">
        <img src="../img/back.svg" style="cursor: pointer;" @click="() => { show = 'mainscreen' }" alt="Qr Code">
      </div>
      <div slot="center" v-if="room">
        Features
      </div>
      <div slot="right">
      </div>
    </ChatBoxTitle>

    <div class="feature-panel">
      <div class="chatty-btns" v-if="isRoomAdminLoggedIn()">
        <button class="chatty-btn" @click="logoutRoom()">Logout</button>
        <!-- <button class="chatty-btn hide-desktop" @click="$emit('openMenu', true)">Favourite Rooms</button> -->

        <button class="chatty-btn" @click="changeName()">Change Name</button>
        <button class="chatty-btn" @click="show = 'search'">Search</button>
        <button class="chatty-btn" @click="print()">Transcript</button>
        <button class="chatty-btn" @click="show = 'qrcode'">QRCode</button>
        <button class="chatty-btn" @click="show = 'stats'">Stats</button>
        <button class="chatty-btn" @click="show = 'wordcloud'">Word Cloud</button>

        <button class="chatty-btn" @click="downloadCSV()">CSV</button>

        <button class="chatty-btn" v-if="room && room.sortMethod === 'chat'" @click="sortBy('vote')">Vote Mode</button>
        <button class="chatty-btn" v-if="room && room.sortMethod === 'vote'" @click="sortBy('chat')">Chat Mode</button>
        <button class="chatty-btn" @click="removeRoom()">Remove Room</button>
        <button class="chatty-btn" @click="clearAllRoomMessages()">Clear Room Messages</button>

        <button class="chatty-btn" @click="show = 'online'">Online List</button>
      </div>
      <div  v-if="!isRoomAdminLoggedIn() && roomHasPW()">
        <input style="transform: translateY(3px);" @keypress.enter="loginRoom()" type="password" v-model="roomPW">
        <button class="chat button" @click="loginRoom()">Login</button>
        <span class="error-msg" v-if="loginErrMsg"><br/>{{ loginErrMsg }}</span>
        <hr />
        <div  class="chatty-btns">
          <!-- <button class="chatty-btn" @click="$emit('openMenu', true)">Favourite Rooms</button> -->
          <button class="chatty-btn" v-if="canRecoverPassword" @click="restPW()">Reset Password</button>
          <button class="chatty-btn" @click="show = 'search'">Search</button>
          <button class="chatty-btn" @click="show = 'online'">Online List</button>
          <!-- <button class="chatty-btn hide-desktop" @click="changeName()">Change Name</button> -->
        </div>
      </div>
      <div  class="chatty-btns" v-if="!isRoomAdminLoggedIn() && !roomHasPW()">
        <!-- <button class="chatty-btn" @click="show = 'search'">Search</button> -->
        <button class="chatty-btn" @click="changeName()">Change Name</button>
        <button class="chatty-btn" @click="show = 'online'">Online List</button>
        <!-- <button class="chatty-btn hide-desktop" @click="$emit('openMenu', true)">Favourite Rooms</button> -->
      </div>
    </div>
  </div>

  <div class="animation-view" v-if="showFlower">
    <EmojiFlower @close="showFlower = false" :emoji="showFlower" />
  </div>

  <div class="drawboard" v-show="show === 'drawboard'" >
    <FabricBoard @sending="(v) => { sending = v }" @send="onSendImage" @show="(v) => { show = v }" ref="drawboard" />
  </div>

  <div class="drawboard" v-show="show === 'myscript'" >
    <MyScript v-if="show === 'myscript'"  @send="onSendLatex" @show="(v) => { show = v }" ref="myscript" />
  </div>

  <div class="overlay" v-if="show === 'qrcode'">
    <div class="qrcode-area" v-if="getQRURL()">
      <qrcode :value="getQRURL()" :pinNumber="pinNumber" :options="{ size: 300 }" />
      <a :href="getQRURL()"><h2>{{ getQRURL() }}</h2></a>
      <br />
      <button @click="show = 'mainscreen'">back</button>
    </div>
  </div>

  <div class="overlay" v-if="show === 'wordcloud'">
    <div class="word-cloud">
      <button @click="show = 'mainscreen'">back</button>
      <WordCloud v-if="roomID" :roomID="roomID" />
    </div>
  </div>

  <div class="overlay" v-if="show === 'search'">
    <div class="search-area">
      <SearchArea :isRoomAdminLoggedIn="isRoomAdminLoggedIn()" :roomPW="roomPW" @back="show = 'mainscreen'" v-if="roomID" :roomID="roomID" />
    </div>
  </div>

  <div class="overlay" v-if="show === 'online'">
    <div class="online-area">
      <OnlineArea :info="onlineInfo" @back="show = 'mainscreen'" v-if="roomID && onlineInfo" :roomID="roomID" />
    </div>
  </div>

  <!-- <div class="overlay" v-if="show === 'poll'">
    <div class="poll-area">
      <PollArea :isRoomAdminLoggedIn="isRoomAdminLoggedIn()" @back="show = 'mainscreen'" v-if="roomID" :roomID="roomID" />
    </div>
  </div> -->

  <div class="overlay" v-if="show === 'stats'">
    <div class="stats-area" v-if="getQRURL()">
      <Stats
        v-if="roomID"
        :roomID="roomID"
        :roomAdminPassword="roomPW"
        @back="show = 'mainscreen'"
      />
      <!-- <button >back</button> -->
    </div>
  </div>

  <!-- <div class="overlay translucent" v-if="show === 'login'">
    <div class="login-area">
      <AuthSocial :redirect="redirect"></AuthSocial>
    </div>
  </div> -->

  <SenderService @upload-progress="(v) => { uploadProgress = v }" @sending="(v) => { sending = v }" @reset="onReset" :roomID="roomID" @show="(v) => { show = v }" ref="sender"></SenderService>
</div>
</template>

<script>
// import NProgress from 'nprogress'
import Parts, { API } from '../parts'
// import AuthSocial from '../pages/AuthSocial/AuthSocial.vue'
import { Status } from '../parts/YoNetwork/YoNetwork.js'
import Dialogue2 from '../parts/Dialogue/Dialogue2.vue'

// import { API } from '@/yoteach2-gui/parts/index.js'
// import axios from 'axios'
import * as jsonexport from 'jsonexport/dist'
import ChatBoxTitle from './ChatBoxTitle.vue'
import TextInputer from './TextInputer.vue'
import qrcode from '@xkeshi/vue-qrcode'

const RESTORE_LAST_WORD = 'restore-send-field'

export default {
  props: {
    roomID: {
      default () {
        return this.$route.params.roomID
      }
    }
  },
  components: {
    qrcode,
    ...Parts,
    // AuthSocial,
    ChatBoxTitle,
    TextInputer,
    Dialogue2
  },
  computed: {
    currentReplyMsg () {
      return this.getReplyMsg({ id: this.replyToID }) || false
    }

    // roomID () {
    //   return this.$route.params.roomID
    // }
  },
  data () {
    return {
      pinNumber: false,
      loggedIn: false,
      redirect: window.location.href,
      showFlower: false,
      msgs: [],
      replyToID: false,
      canRecoverPassword: false,
      focused: false,
      uploadProgress: false,
      session: false,
      sending: false,
      room: false,
      roomPW: '',
      loginErrMsg: false,
      show: 'mainscreen',
      onlineInfo: false
    }
  },
  beforeDestroy () {
    API.leaveKeepRoom({ roomID: this.roomID })
  },
  mounted () {
    this.getRoom()
    this.joinRoom()

    API.joinKeepRoom({
      roomID: this.roomID,
      nickname: API.Status.state.chatter.name,
      deviceID: API.Status.state.chatter.uuid
    })
    API.onChangeOnlineCounter({
      roomID: this.roomID,
      onChange: (data) => {
        console.log(data)
        this.onlineInfo = data
      }
    })
    API.checkOnline({ roomID: this.roomID })

    // API.check()
    //   .then(() => {
    //     this.loggedIn = true
    //   })

    // var resizer = () => {
    //   if (window.innerWidth >= 767) {
    //     this.focused = true
    //   }
    // }
    // resizer()
    // window.addEventListener('resize', resizer, false)

    let restore = window.localStorage.getItem(RESTORE_LAST_WORD)
    if (restore) {
      // window.localStorage.removeItem(RESTORE_LAST_WORD)
      this.onTextInput({ text: restore })
    }
  },
  methods: {
    changeName () {
      let name = window.prompt(`What's your new name?`)
      if (name) {
        let info = JSON.parse(JSON.stringify({
          name
        }))
        Status.setChatter({ chatter: info })
        window.alert(`Your name is changed.`)
        window.location.reload()
      }
    },
    displayPin (pinNumber) {
      return this.pad(Number(pinNumber), 8).split('')
        .reduce((c, p, i) => {
          if (i % 4 === 0 && i !== 0) {
            c += `-${p}`
          } else {
            c += `${p}`
          } return c
        }, '').trim()
    },
    pad (n, width, z) {
      z = z || '0'
      n = n + ''
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
    },
    async refreshPin () {
      let resp = await API.remakeAndGetLatestPin({ roomAdminPassword: this.roomPW, roomID: this.room._id })
      let data = resp.data
      this.pinNumber = data.pin
    },
    clearAllRoomMessages () {
      if (window.prompt('please type clear-all-messages to remove all messages witin this room.') === 'clear-all-messages') {
        API.clearAllRoomMessages({
          room: this.room,
          roomPW: this.roomPW
        })
      }
    },
    onViewReply ({ msg }) {
      console.log(msg)
    },
    getReplyMsg ({ id }) {
      return this.msgs.find(m => m._id === id)
    },
    onReply ({ reply, msgs }) {
      this.msgs = msgs
      this.replyToID = reply._id
      this.$refs.sender.onReply({ reply })
    },
    checkCanRecoverAdminPW () {
      API.checkCanRecoverAdminPW({
        roomID: this.room._id
      })
        .then((resp) => {
          console.log(resp)
          this.canRecoverPassword = resp.data.canRecoverPassword
        })
    },
    downloadCSV () {
      this.getAllMessages()
    },
    getAllMessages () {
      API.getAllMessageOfRoom({ roomAdminPassword: this.roomPW, roomID: this.room._id })
        .then((resp) => {
          console.log(resp)
          this.toCSV(resp.data.map((item, index) => {
            return {
              item: index + 1,
              date: new Date(item['created_at']),
              senderName: item['senderName'],
              type: item['type'],
              message: item['text'],
              image: item['imgURL'],
              goodAsk: item['goodAsk'],
              voteCount: item['voteUpUUID'].length
            }
          }))
        })
    },
    toCSV (info) {
      jsonexport(info, (err, csv) => {
        if (err) {
          return console.log(err)
        }
        console.log(csv)
        var blob = new Blob([csv], { type: 'application/csv' })
        var url = URL.createObjectURL(blob)
        var link = document.createElement('a')
        link.setAttribute('href', url)
        link.setAttribute('download', 'messages.csv')
        link.click()
      })
    },

    restPW () {
      this.$router.push('/password-recovery/' + this.room._id)
    },
    print () {
      window.print()
    },
    removeRoom () {
      if (window.prompt('please eneter room password again to remove room:') !== this.roomPW) {
        return
      }
      API.removeRoom({
        room: this.room,
        roomPW: this.roomPW
      })
    },
    loginRoom () {
      this.session.login({ roomID: this.roomID, roomAdminPassword: this.roomPW })
        .then(() => {
          this.$forceUpdate()
          this.loginErrMsg = ''
          return Promise.resolve()
        }, () => {
          this.loginErrMsg = 'bad password'
          return Promise.reject(new Error(this.loginErrMsg))
        })
        .then(() => {
          this.session.addAdmin({ roomID: this.roomID, roomAdminPassword: this.roomPW, uuid: API.Status.state.chatter.uuid })
            .then((resp) => {
              this.room = resp.data
            })
        })
        .then(() => {
          API.getLatestPin({ roomID: this.roomID, roomAdminPassword: this.roomPW }).then((resp) => {
            console.log(resp)
            this.pinNumber = resp.data.pin
          })
        })
    },
    logoutRoom () {
      // let roomPW = this.roomPW
      this.roomPW = ''
      this.session.logout()
        .then(() => {
          // this.session.removeAdmin({ roomID: this.roomID, roomAdminPassword: roomPW, uuid: API.Status.state.chatter.uuid })
          // .then((resp) => {
          //   this.room = resp.data
          // })
          this.$forceUpdate()
        })
    },
    roomHasPW () {
      return this.room && this.room.enableRoomAdminFeatures
    },
    isRoomAdminLoggedIn () {
      return this.session && this.session.hasPW()
    },
    cleanBoard () {
      // fill with transparent pixel
      this.$nextTick(() => {
        this.$refs['drawboard'].reset({ imageURL: false })
      })
    },
    onFileChange (evt) {
      let file = evt.target.files[0]
      if (file) {
        var reader = new FileReader()
        reader.onload = () => {
          this.$refs['drawboard'].reset({ imageURL: reader.result })
        }
        this.show = 'drawboard'
        reader.readAsDataURL(file)
      }
    },
    onTextInput (v) {
      if (v.text.indexOf('<3') !== -1) {
        this.showFlower = '❤️'
      } else if (v.text.indexOf(':)') !== -1) {
        this.showFlower = '😀️'
      } else if (v.text.indexOf(':D') !== -1) {
        this.showFlower = '😂'
      }
      if (!this.loggedIn) {
        window.localStorage.setItem(RESTORE_LAST_WORD, v.text)
      }
      this.$refs.sender.onTextInput(v)
    },
    async sendGate () {
      if (!this.loggedIn) {
        try {
          await API.check()
          this.loggedIn = true
          window.localStorage.removeItem(RESTORE_LAST_WORD)
        } catch (e) {
          this.loggedIn = false
          this.show = 'login'
          return Promise.reject(new Error('no login'))
        }
      }
    },
    async onSendPoll () {
      let newMsg = await this.$refs.sender.onSendPoll()
      console.log(newMsg)
      /*
      {
        "userID": "",
        "yohkMessageID": "",
        "type": "poll",
        "imgBucket": "yoteach",
        "replyQuote": "",
        "goodAsk": false,
        "voteUpUUID": [],
        "isPinned": false,
        "_id": "5c3ee65017e9831bda5e7547",
        "roomID": "5c11f05db17ea42e6153ab0e",
        "text": "123",
        "imgUUID": "",
        "imgExt": "",
        "imgFileName": "",
        "imgURL": "",
        "imgWidth": 1,
        "imgHeight": 1,
        "date": "2019-01-16T08:07:44.921Z",
        "senderUUID": "b0bafa38-b30e-4e62-9195-203c120300f9",
        "senderName": "loklok",
        "created_at": "2019-01-16T08:07:44.922Z",
        "updated_at": "2019-01-16T08:07:44.922Z",
        "__v": 0
      }
      */
      // console.log(newPoll)
      this.replyToID = false

      this.sortBy('chat')
    },
    async onSendLatex ({ latex }) {
      this.$refs.sender.onSendLatex({ latex })
      this.replyToID = false
    },
    async onSendText () {
      // await this.sendGate()
      this.$nextTick(() => {
        this.$refs.sender.onSendText()
        this.replyToID = false
      })
    },
    async onSendImage (v) {
      // await this.sendGate()
      this.$refs.sender.onSendImage(v)
      this.replyToID = false
    },
    onReset () {
      this.replyToID = false
      this.$refs.textinput.text = ''
    },
    onRemix ({ msg }) {
      this.show = 'drawboard'
      let url = msg.imgURL
      if (msg.imgBucket && msg.imgUUID && msg.imgExt) {
        url = `${API.PROXY_URL}/${msg.imgBucket}/${msg.imgUUID}.${msg.imgExt}`
        // url = `https://${msg.imgBucket}.s3.amazonaws.com/${msg.imgUUID}.${msg.imgExt}`
        // url = `${msg.imgBucket}.s3-accelerate.amazonaws.com/${msg.imgUUID}.${msg.imgExt}`
        // yo/proxy/yoteach-production.s3.amazonaws.com/5aa24dd25c463611c7137a91.png
      }

      this.$refs['drawboard'].reset({ imageURL: url })

      // NProgress.start()
      // this.show = 'drawboard'
      // this.$nextTick(() => {
      //   let url = msg.imgURL
      //   if (msg.imgBucket && msg.imgUUID && msg.imgExt) {
      //     url = `${API.PROXY_URL}/${msg.imgBucket}/${msg.imgUUID}.${msg.imgExt}`
      //     // url = `https://${msg.imgBucket}.s3.amazonaws.com/${msg.imgUUID}.${msg.imgExt}`
      //     // url = `${msg.imgBucket}.s3-accelerate.amazonaws.com/${msg.imgUUID}.${msg.imgExt}`
      //   }
      //   this.$refs['drawboard'].reset({ imageURL: false })
      //   axios.get(url, {
      //     responseType: 'arraybuffer'
      //   }).then(resp => {
      //     var objURL = window.URL.createObjectURL(new Blob([resp.data], { type: 'image/jpeg' }))
      //     this.$refs['drawboard'].reset({ imageURL: objURL })
      //     NProgress.done()
      //   })
      // })
      // console.log(msg)
    },
    getQRURL () {
      if (this.room) {
        return `https://yoteachapp.com/${this.room.title}`
      } else {
        return false
      }
    },
    getRoom () {
      API.getRoom({ _id: this.roomID })
        .then((resp) => {
          this.room = resp.data
          this.session = API.makeSessionForRoom({ roomID: this.roomID })
        })
        .then(() => {
          this.checkCanRecoverAdminPW()
        })
    },
    joinRoom () {
      API.joinRoom({ roomID: this.roomID })
    },
    isCurrentUserMuted () {
      if (!this.room) {
        return false
      }
      let list = this.room.mutedUUIDs
      let userUUID = API.Status.state.chatter.uuid
      return list.includes(userUUID)
    },
    onRoomChange () {
      // API.onRoomChange({
      //   roomID: this.roomID,
      //   updateRoom: (data) => {
      //     this.room = data
      //   }
      // })
    },
    sortBy (mode) {
      this.room.sortMethod = mode
      API.switchRoomMode({ roomID: this.roomID, sortMethod: mode, roomAdminPassword: this.roomPW })
        .then((resp) => {
          console.log(resp.data)
        })
      API.roomChanged(this.room)
    }
  }
}
</script>

<style scoped>
/*
new layout
*/
.title-link,
.title-link:visited,
.title-link:active,
.title-link:hover{
  color: white;
  text-decoration: underline;
}

.chatty-btns{
  display: flex;
  flex-wrap: wrap;
  justify-items: space-around;
}

.chatty-btn{
  /* display: inline-block; */
  /* height: 38px; */
  padding: 0 30px;
  color: #555;
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  /* line-height: 38px; */
  letter-spacing: .1rem;
  text-transform: uppercase;
  text-decoration: none;
  /* white-space: nowrap; */
  background-color: transparent;
  border-radius: 4px;
  border: 1px solid #bbb;
  cursor: pointer;
  /* -webkit-box-sizing: border-box; */
  box-sizing: border-box;
  height: 130px;
  width: 130px;
  white-space: pre-line;
  line-height: 20px;
  display: block;
  margin: 10px;
}

.feature-panel{
  margin: 30px;
}
.overlay-layer{
  height: 100%;
}
.chatty-conversation{
  height: calc(100% - 55px);
}

.dialogue-area{
  height: calc(100% - 40px);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.bottom-input-area{
  overflow: hidden;
  height: 40px;
}

.focused .dialogue-area{
  height: calc(100% - 80px);
}

.focused .bottom-input-area{
  height: 80px;
}
@media screen and (min-width: 767px) {
  .focused .dialogue-area{
    height: calc(100% - 40px);
  }
  .focused .bottom-input-area{
    height: 40px;
  }
}

.reply-block{
  position: absolute;
  bottom: 40px;
  right: 0px;
  width: 100%;
  border-radius: 5px;
  text-align: left;
  padding: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background-color: rgba(0,0,0,0.2);
}
.reply-block .label{
  border-left: rgb(0, 255, 179) solid 3px;
  padding-left: 10px;
  background-color: white;
}
.img-preview{
  width: 100%;
}
.focused .reply-block{
  bottom: 80px;
}
@media screen and (min-width: 767px) {
  .focused .reply-block{
    bottom: 40px;
  }
  .reply-block{
    width: calc(100% - 250px - 50px);
  }
}

.input-group{
  background: white;
  display: flex;
  /* align-items: flex-end; */
}
.you-are-muted{
  font-size: 18px;
  font-weight: bold;
  margin: 10px;
}

.overlay.translucent{
  background-color: rgba(0,0,0,0.95);
}

.login-area{
  margin:35px 5%;
  width: 90%;
}

.animation-view{
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100vw;
  height: 1px;
}

.drawboard{
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  background-color: white;
  width: 100%;
  height: 100%;
}
.overlay{
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  background-color: white;
  width: 100%;
  height: 100%;
}

.qrcode-area{
  margin-top:60px;
  text-align: center;
}

.show-desktop{
  display: none;
}
@media screen and (min-width: 767px) {
  .show-desktop{
    display: block;
  }
  .hide-desktop{
    display: none;
  }
}
.button.icon{
  border: none;
  margin-bottom: 0px;
}

.red-circle-icon{
  display: inline-block;
  height: 40px;
  width: 38px;
  padding: 8px;
  color: #555;
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  line-height: 38px;
  letter-spacing: .1rem;
  text-transform: uppercase;
  text-decoration: none;
  white-space: nowrap;
  background-color: #c72132;
  /* border-radius: 50%; */
  /* border: 1px solid #bbb; */
  cursor: pointer;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  /* transform: scale(1.5); */
}

.button.icon{
  margin: 5px;
  width: calc(40px - 5px * 2);
  height: calc(40px - 5px * 2);
}
</style>
